import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { LAYOUT_PATH, WIDGET_SELECTION_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";
import { notBlank } from "../../shared/validations";

const CAPTION_SPELL_NAME = "caption";

const FillOrigamiStepProps = {
  previous: LAYOUT_PATH,
  next: WIDGET_SELECTION_PATH,
  question: "Please confirm your <%= target %>",
  target: "offer text",
  description: "Update it or simply check for typos.",
  spellName: CAPTION_SPELL_NAME,
  placeholder: "Memorial Day Sale starting May 1st!",
  validation: notBlank,
  showExpanded: false,
};

export const OfferTextStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(OfferTextStep);
